"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WRITTEN = exports.USER_GENERATED = exports.PROGRAMMATIC_TO_WRITTEN = exports.PROGRAMMATIC = void 0;
exports.PROGRAMMATIC = "programmatic";
exports.PROGRAMMATIC_TO_WRITTEN = "programmaticToWritten";
exports.USER_GENERATED = "userGenerated";
exports.WRITTEN = "written";